export default __webpack_public_path__ + "static/media/basic-iphone.fd10b20f.png";